import axios from "axios";
import apiConfig from "./endpoint";
import environment from "environment";
export const registerDocAssembleUser = (...args) => {
  return axios.post(apiConfig.docAssemble.NewUser, ...args);
};

export const getLoginUrlDocAssemble = (...args) => {
  return axios.get(apiConfig.docAssemble.LoginURL, ...args);
};

export const logoutDocAssemble = async (...args) => {
  await axios.get(environment.baseurl + apiConfig.docAssemble.Logout, ...args);
};

export const getSessionDocAssemble = async (params) => {
  return await axios.get(apiConfig.docAssemble.Session, { params });
};

export const getAnswerDocAssemble = async (params) => {
  //   return await axios.get(
  //     "https://localhost:7086/api/1/docassemble_proxy/answers",
  //     { params }
  //   );
  return await axios.get(apiConfig.docAssemble.Answer, { params });
};

export const getDeathInfoFromElit = async (...args) => {
  return await axios.post(apiConfig.elit.ICA, ...args);
};

// [START] Step 4: Document Checklist
export const getDocumentChecklists = async (params) => {
  return await axios.get(apiConfig.probate.GetDocuments, { params });
  // localhost test
  // return await axios.get("https://localhost:44328/api/1/documentchecklist/get_documents", { params })
};

export const downloadDocument = async (params) => {
  return await axios.get(apiConfig.probate.DownloadDocument, {
    params,
    method: "GET",
    responseType: "blob", //Force to receive data in a Blob Format
  });
  // localhost test
  //return await axios.get('https://localhost:44328/api/1/documentchecklist/download_document', {
  //     params,
  //     method: 'GET',
  //    responseType: 'blob' //Force to receive data in a Blob Format
  // })
};

export const updateDocumentsChecklist = async (...args) => {
  return await axios.post(apiConfig.probate.UpdateDocumentsChecklist, ...args);
  // localhost test
  // return await axios.post('https://localhost:44328/api/1/documentchecklist/update_documents_checklist', ...args)
};

export const CheckIsResubmittedPhase = async (params) => {
  return await axios.get(apiConfig.probate.CheckIsResubmittedPhase, { params });
  // return await axios.get("https://localhost:44328/api/1/documentchecklist/check_isresubmitted_phase", { params })
};

// [END] Step 4: Document Checklist

export const GetCaveatICASearchResult = async (params) => {
  return await axios.get(apiConfig.probate.CaveatICA, { params });
};

export const SaveICACorrectness = async (...args) => {
  return await axios.post(apiConfig.probate.ICACorrectness, ...args);
};

export const CheckApplicantAddress = async (params) => {
  return await axios.get(apiConfig.probate.CheckApplicantAddress, { params });
};

// [START] Step 5: Schedule Of Assets

export const getGeneratedPdf = async (params) => {
  //   return await axios.get(
  //     "https://localhost:7086/api/1/scheduleofassets/generated_pdf" +
  //       "/" +
  //       params.fileId,
  //     {
  return await axios.get(
    apiConfig.probate.GetGeneratedSOA + "/" + params.fileId,
    {
      method: "GET",
      responseType: "blob",
    }
  );
};

export const checkSOA = async (params) => {
  return await axios.get(apiConfig.probate.CheckSOA, { params });
};

export const setLateSoa = async (params) => {
  return await axios.post(apiConfig.probate.SetLateSoa, { params });
};

export const getSoaDoc = async (params) => {
  return await axios.get(apiConfig.probate.GetSoaDoc, { params });
};

export const GetLatestSoa = async (params) => {
  return await axios.get(apiConfig.probate.GetLatestSoa, { params });
};

// [END] Step 5: Schedule Of Assets

export const getHome = async (params) => {
  return await axios.get(apiConfig.probate.Landing, { params });
};

export const SaveRoute = async (params) => {
  return await axios.get(apiConfig.probate.SaveRoute, { params });
};

export const CalculateFees = async (...args) => {
  return await axios.post(apiConfig.probate.CalculateFees, ...args);
  //return await axios.post("https://localhost:7086/api/1/payment/calculate_fees", ...args)
};

export const CheckMainSubmissionDone = async (params) => {
  return await axios.get(apiConfig.probate.CheckMainSubmissionDone, { params });
  //return await axios.get("https://localhost:7086/api/1/payment/check_mainsubmission_done");
};

export const PdfValidate = async (...args) => {
  return await axios.post(apiConfig.probate.PdfValidate, ...args);
  //return await axios.get("https://localhost:7086/api/1/common/pdf_validate");
};

export const PdfValidate2 = async (...args) => {
  return await axios.post(apiConfig.probate.PdfValidate2, ...args);
  //return await axios.get("https://localhost:7086/api/1/common/pdf_validate");
};

export const ProceedToRefund = async (...args) => {
  return await axios.post(apiConfig.probate.ProceedToRefund, ...args);
  //return await axios.post("https://localhost:7086/api/1/refund/proceed_to_refund", ...args)
};

export const ProceedToPay = async (...args) => {
  return await axios.post(apiConfig.probate.ProceedToPay, ...args);
  //return await axios.post("https://localhost:7086/api/1/payment/proceed_to_pay", ...args)
};

export const ProceedToSettle = async (...args) => {
  return await axios.post(apiConfig.probate.ProceedToSettle, ...args);
  //return await axios.post("https://localhost:7086/api/1/payment/proceed_to_settle", ...args)
};

export const GetRefundDetails = async (params) => {
  return await axios.get(apiConfig.probate.GetRefundDetails, { params });
  //return await axios.get("https://localhost:7086/api/1/refund/get_refund_details",  { params })
};

export const GetWithdrawalDetails = async (params) => {
  return await axios.get(apiConfig.probate.GetWithdrawalDetails, { params });
  //return await axios.get("https://localhost:7086/api/1/refund/get_withdrawal_details",  { params })
};

export const WithdrawProbateCase = async (...args) => {
  return await axios.post(apiConfig.probate.WithdrawProbateCase, ...args);
  // return await axios.post("https://localhost:7086/api/1/refund/withdraw_probate_case", ...args)
};

export const getCountries = async (params) => {
  return await axios.get(apiConfig.probate.GetCountries, { params });
};

export const GetCaseCode = async () => {
  return await axios.get(apiConfig.probate.GetCaseCode);
};

export const GetCaseStatus = async () => {
  return await axios.get(apiConfig.probate.GetCaseStatus);
  //return await axios.get("https://localhost:7086/api/1/refund/get_refund_details",  { params })
};

export const GetPaymentAndFeeDetails = async (...args) => {
  return await axios.post(apiConfig.probate.GetPaymentAndFeeDetails, ...args);
  //return await axios.post("https://localhost:7086/api/1/payment/get_payment_fee_details", ...args)
};

export const submitAdminOathAffidavit = async (params) => {
  //   return await axios.post(
  //     "https://localhost:7086/api/1/adminoathaffidavit/submit_admin_oath_affidavit",
  return await axios.post(
    apiConfig.probate.SubmitAdminOathAffidavitDocuments,
    params
  );
};

export const submitSupplementaryAffidavit = async (params) => {
  //   return await axios.post(
  //     "https://localhost:7086/api/1/adminoathaffidavit/submit_supplementary_affidavit",
  return await axios.post(
    apiConfig.probate.SubmitSupplementaryAffidavitDocuments,
    params
  );
};

export const getAdminOathAffidavitDocumentList = async (params) => {
  //   return await axios.get(
  //     "https://localhost:7086/api/1/adminoathaffidavit/document_list",
  //     {
  return await axios.get(apiConfig.probate.GetAdminOathAffidavitDocumentList, {
    params,
  });
};

export const getAdminOathAffidavitInformation = async (params) => {
  //   return await axios.get(
  //     "https://localhost:7086/api/1/adminoathaffidavit/get_info",
  return await axios.get(
    apiConfig.probate.GetAdminOathAffidavitInformation,
    params
  );
};

export const getAdminOathAffidavitPdf = async (params) => {
  //   return await axios.get(
  //     "https://localhost:7086/api/1/adminoathaffidavit/generated_pdf" +
  //       "/" +
  //       params.fileId,
  return await axios.get(
    apiConfig.probate.GetAdminOathAffidavitPdf + "/" + params.fileId,
    {
      method: "GET",
      responseType: "blob",
    }
  );
};

export const requestAdminOathAffidavitTimeExtension = async (params) => {
  //   return await axios.post(
  //     "https://localhost:7086/api/1/adminoathaffidavit/request_time_extension",
  return await axios.post(
    apiConfig.probate.RequestAdminOathAffidavitTimeExtension,
    params
  );
};

export const GetNotificationDocuments = async (params) => {
  return await axios.get(apiConfig.probate.Notification_Documents, { params });
};

// [START] Step 8: Hearing

export const GetHearingDetails = async (params) => {
  return await axios.get(apiConfig.probate.GetHearingDetails, { params });
};

export const DownloadOIT = async (params) => {
  return await axios.get(apiConfig.probate.DownloadOIT, {
    params,
    method: "GET",
    responseType: "blob", //Force to receive data in a Blob Format
  });
};

// [END] Step 8: Hearing

export const GetPaymentHistory = async (params) => {
  return await axios.get(apiConfig.probate.GetPaymentHistory, { params });
  // localhost test
  // return await axios("https://localhost:7086/api/1/payment/get_payment_trans");
};

export const GetGrantStatus = async (params) => {
  return await axios.get(apiConfig.probate.GrantStatus, { params });
};

export const DownloadGrant = async (params) => {
  return await axios.get(apiConfig.probate.DownloadGrant, { params });
};

export const Logout = (...args) => {
  return axios.get(apiConfig.probate.Logout, ...args);
};

export const callbackAfterLogin = (...args) => {
  return axios.get(apiConfig.probate.CallbackAfterLogin, ...args);
};

export const checkAutoLoginSession = (...args) => {
  return axios.get(apiConfig.probate.CheckAutoLoginSession, ...args);
};

export const GetProbateStatus = async (params) => {
  return await axios.get(apiConfig.probate.GetProbateStatus, { params });
};

export const GetShouldSoaDisabled = async (params) => {
  return await axios.get(apiConfig.probate.ShouldSoaDisabled, { params });
};

export const reportBrowserError = async (params) => {

  return await axios.post(
    apiConfig.probate.ErrorReporter,
    params
  );
};
